import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import { getEmojiNativeText } from '../../utils/emojis';

var Emoji =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Emoji, _React$PureComponent);

  function Emoji() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Emoji);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Emoji)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      event.preventDefault();

      _this.props.onClick(event, _this.props.emoji, _this.props.index);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseMove", function (event) {
      _this.props.onSelect(event, _this.props.emoji, _this.props.index);
    });

    return _this;
  }

  _createClass(Emoji, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          index = _this$props.index,
          emoji = _this$props.emoji,
          _this$props$isSelecte = _this$props.isSelected,
          isSelected = _this$props$isSelecte === void 0 ? false : _this$props$isSelecte,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style;
      return React.createElement("div", {
        alt: emoji.id,
        "data-emoji-index": index,
        onMouseMove: this.onMouseMove,
        onClick: this.onClick,
        className: classNames('editor-emoji-picker-item-native', 'pointer', 'padding-horizontal-smaller', 'radius-normal center-text', 'overflow-hidden center-text', {
          'background-shade-45': isSelected
        }),
        style: _objectSpread({}, style, {
          width: 32,
          height: 32,
          lineHeight: '36px',
          margin: 2,
          display: 'inline-block'
        })
      }, React.createElement("span", {
        style: {
          fontSize: '24px',
          display: 'inline-block',
          textAlign: 'center',
          wordBreak: 'keep-all'
        }
      }, getEmojiNativeText(emoji)));
    }
  }]);

  return Emoji;
}(React.PureComponent);

export default Emoji;